import type { ModalActionHandler } from './modalActionTypes';
import { assignJob, getFreePopulation, MAX_MASONS } from '../map/settlement';
import { getSettlement } from './settlementActionUtils';

export const hireMasonAction: ModalActionHandler = (state, modal) => {
    const settlement = getSettlement(state, modal);
    if (!settlement) return false;
    const freePop = getFreePopulation(settlement);
    const cap = MAX_MASONS * settlement.buildings.masonry.qty;
    if (settlement.jobs.masons >= cap || freePop <= 0) return false;
    if (!assignJob(settlement, 'masons')) return false;
    return true;
};
